/** Miroir serveur `offline_session_service` / `offline_session`. */

export const OFFLINE_SESSION_HEARTBEAT_STALE_SEC = 180
export const OFFLINE_MIN_ABSENCE_SEC = 5 * 60
